import { jsx as _jsx } from "react/jsx-runtime";
import * as RadixPortal from "@radix-ui/react-portal";
import { memo, useEffect, useState } from "react";
export const Portal = /*#__PURE__*/ memo((props)=>{
    const [isMounted, setIsMounted] = useState(false);
    useEffect(()=>setIsMounted(true), []);
    return isMounted ? /*#__PURE__*/ _jsx(RadixPortal.Root, {
        ...props
    }) : null;
});
Portal.displayName = "Portal";
